import { type ComputedRef, computed, type Ref } from 'vue'
import { useToast } from '@/composables/useToast'

export function useMobileNumber(
  mobile: Ref<string | number | undefined> | ComputedRef<string | number | undefined>,
  countryCode: Ref<string | number | undefined> | ComputedRef<string | number | undefined>
) {
  const toast = useToast()

  const cleanMobile = computed(() => {
    if (!mobile.value) return ''
    return String(mobile.value).replace(/\D/g, '').replace(/^0+/, '')
  })

  const cleanCountryCode = computed(() => {
    return String(countryCode.value || '').replace(/\D/g, '')
  })

  const fullNumber = computed(() => {
    if (!cleanMobile.value) return ''
    return `+${cleanCountryCode.value}${cleanMobile.value}`
  })

  const whatsappLink = computed(() => {
    if (!cleanMobile.value) return undefined
    return `https://wa.me/${cleanCountryCode.value}${cleanMobile.value}`
  })

  const copyMobileNumber = async () => {
    if (!cleanMobile.value) return
    try {
      await navigator.clipboard.writeText(fullNumber.value)
      toast.success('شماره موبایل کپی شد')
    } catch {
      toast.error('کپی کردن شماره با خطا مواجه شد', 'خطا')
    }
  }

  return { whatsappLink, copyMobileNumber, fullNumber, cleanMobile, cleanCountryCode }
}
